// asset imports
import "@/assets/scss/material-dashboard.scss";

export default {};
